<template>
  <div class="section">
    <div class="container">
      <div class="container__inner px-1.5">
        <div
          class="relative flex flex-col flex-wrap justify-between w-full lg:flex-row"
        >
          <div class="lg:w-9/12">
            <div class="flex items-center section-title">
              <CircleIcon
                class="text-black fill-current mr-0.5 h-0.625 w-0.625 lg:h-1 lg:w-1"
              />
              <span class="text-sm uppercase lg:text-base">Mon Ludic</span>
            </div>
            <h1
              class="block m-0 leading-none text-4xl lg:text-6xl font-normal py-1 lg:py-2.5"
            >
              {{ quizStore.quiz.title }}
            </h1>
          </div>
        </div>
        <!-- .flex -->
        <breadcrumb />

        <div v-if="isDev">
          {{ quizStore.getScores() }}
          {{ quizStore.getScore() }}
        </div>
        <!-- .step-breadcrumb -->
      </div>
      <!-- .container__inner -->
    </div>
    <!-- .container -->
  </div>
  <!-- .section -->
</template>
<script setup>
import { useQuizStore } from "@/stores/quiz";
import Breadcrumb from "@/components/Breadcrumb.vue";
import CircleIcon from "@/components/icons/CircleIcon.vue";
const quizStore = useQuizStore();
const isDev = document.location.hostname.match(/(localhost|monudi.test)/);
</script>
